import { proxyCustomElement, HTMLElement, h, Host, Fragment } from '@stencil/core/internal/client';

const dividerCss = ":host{align-items:center;display:flex;justify-content:center}.line{background-color:var(--jw-theme-surface-divider-color);flex:1;height:1px;width:100%}.or-text{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;padding:.25rem .75rem;text-transform:uppercase}:host([type=vertical]){min-height:100%;width:1px}:host([type=vertical]) .line{height:100%;max-height:100%;min-height:1.5rem;width:100%}";
const WuiDividerStyle0 = dividerCss;

const WuiDivider = /*@__PURE__*/ proxyCustomElement(class WuiDivider extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = 'horizontal';
    }
    render() {
        return (h(Host, { key: '1805c5af3dc7351fdd9644720148756c4e5926a3' }, h("div", { key: 'cc26e382c907c25e335f0d3fb08a50cecbc01237', class: "line" }), this.type === 'horizontal-or' && (h(Fragment, { key: '79600f85d4079ae4a1fefdb2b6545366f62828a1' }, h("div", { key: '46e65f0a5ae368c5293364b042f4db4bb130cc24', class: "or-text" }, "OR"), h("div", { key: '36537625526257051298d25e7d283675f0a2ee3e', class: "line" })))));
    }
    static get style() { return WuiDividerStyle0; }
}, [1, "wui-divider", {
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDivider);
            }
            break;
    } });
}
defineCustomElement();

export { WuiDivider as W, defineCustomElement as d };

//# sourceMappingURL=divider.js.map